import { Icon } from '../icons';

export const DEFAULT_ICONS_FOR_STATEFUL_BUTTON = {
  default: undefined,
  pending: <Icon type="spinner" svgProps={{ className: 'icon-spin' }} />,
  complete: <Icon type="check-outline" />,
  error: <Icon type="error" />,
};
